module.exports = __webpack_public_path__ + "img/57.3dd456ad.jpg";